
//export  const BASE_API_URL = 'http://185.201.113.99:28000'
//export  const BASE_API_URL = 'https://localhost'
//export  const BASE_API_URL = 'https://pietrzko.online'
//export  const BASE_API_URL = 'http://localhost:48000'
export const BASE_API_URL = 'https://crm.expopropertygroup.pl'